import { BackendUser as User } from '@/infrastructure/clients/BackendClient';

export function getUserName(user: User | null): string {
  if (!user) return '';
  
  // Try to get full_name from user metadata first
  const fullName = user.user_metadata?.full_name;
  if (fullName) return fullName;
  
  // Fall back to email if no name is available
  return user.email || '';
}

export function getUserAvatar(user: User | null): string {
  if (!user) return '';
  
  // Try to get avatar from user metadata
  const avatar = user.user_metadata?.avatar_url;
  if (avatar) return avatar;
  
  // Return empty string if no avatar
  return '';
}

export function getUserAvatarCrop(user: User | null): { x: number; y: number; width: number; height: number } | null {
  if (!user) return null;
  
  // Try to get avatar crop from user metadata
  const crop = user.user_metadata?.avatar_crop;
  if (crop && typeof crop === 'object' && 'x' in crop && 'y' in crop && 'width' in crop && 'height' in crop) {
    return crop as { x: number; y: number; width: number; height: number };
  }
  
  return null;
}

export function getUserInitial(user: User | null): string {
  if (!user) return '';
  
  const name = getUserName(user);
  if (!name) return '';
  
  // Get first letter of first word
  return name.charAt(0).toUpperCase();
} 